export default "__VITE_ASSET__ec95e17a__"